// src/components/ModalAgregarClienteWifi.jsx
import React, { useEffect, useState } from "react";
import "./ModalAgregarClienteWifi.css";
import { authFetch } from "../utils/authFetch";

export default function ModalAgregarClienteWifi({ onClose, onGuardar }) {
  const [planes, setPlanes] = useState([]);
  const [nodos, setNodos] = useState([]);
  const [errorNodos, setErrorNodos] = useState("");

  const [form, setForm] = useState({
    id: "",
    nodo_id: "",
    nombre: "",
    apellidos: "",
    direccion: "",
    telefono: "",
    colonia: "",
    municipio: "",
    plan: "",
    costo: "",
    ip: "",
    equipo: "0",    // 0 propio, 1 prestado
    comentario: "",
  });

  async function cargarNodos() {
    // Un desplegable vacío no dice si no hay nodos, si falló la consulta
    // o si la sesión caducó. Cada caso se arregla distinto, así que el
    // motivo se guarda y se muestra junto al campo.
    try {
      const res = await authFetch("/api/nodos/listar");
      const data = await res.json().catch(() => ({}));

      if (!res.ok || !data.ok) {
        setErrorNodos(data.mensaje || `El servidor respondió ${res.status}.`);
        return;
      }

      const lista = data.nodos || [];
      setNodos(lista);
      if (lista.length === 0) {
        setErrorNodos("No hay localidades registradas todavía.");
      } else if (lista.length === 1) {
        setForm((f) => ({ ...f, nodo_id: String(lista[0].id) }));
      }
    } catch (e) {
      setErrorNodos(String(e));
    }
  }

  async function cargarPlanesWifi() {
    try {
      const res = await authFetch("/api/clientes_wifi/listar");
      const data = await res.json();
      if (data.ok) setPlanes(data.planes || []);
    } catch (e) {
      console.log("Error cargando planes (wifi):", e);
    }
  }

  useEffect(() => {
    cargarPlanesWifi();
    cargarNodos();
  }, []);

  function handleChangeID(e) {
    // igual estilo de fibra: solo números
    let value = e.target.value.replace(/\D/g, "");
    setForm((f) => ({ ...f, id: value }));
  }

  function actualizarCampo(campo, valor) {
    setForm((f) => ({ ...f, [campo]: valor }));
  }

  function seleccionarPlan(valorPlan) {
    const planSel = planes.find((p) => p.nombre === valorPlan);
    setForm((f) => ({
      ...f,
      plan: valorPlan,
      costo: planSel ? planSel.costo : "",
    }));
  }

  // Instalación (idéntico concepto a fibra)
  const [instalacionCosto, setInstalacionCosto] = useState(0);
  const [instalacionTipo, setInstalacionTipo] = useState("contado"); // contado | meses
  const [instalacionMeses, setInstalacionMeses] = useState(1);

  function guardar() {
    if (!form.nodo_id) {
      alert("Elige la localidad del cliente.");
      return;
    }

    // igual que fibra: obligatorios base
    if (!form.id || !form.nombre || !form.apellidos || !form.plan) {
      alert("Completa los campos obligatorios.");
      return;
    }

    // Instalación NO opcional (como pediste)
    if (!Number(instalacionCosto) || Number(instalacionCosto) <= 0) {
      alert("Falta el costo de instalación.");
      return;
    }

    const payload = {
      id: Number(form.id),
      nombre: (form.nombre || "").trim(),
      apellidos: (form.apellidos || "").trim(),
      direccion: (form.direccion || "").trim(),
      telefono: (form.telefono || "").trim(),
      colonia: (form.colonia || "").trim(),
      municipio: (form.municipio || "").trim(),
      plan: (form.plan || "").trim(),
      costo: Number(form.costo || 0),

      // WiFi extras
      nodo_id: Number(form.nodo_id),
      ip: (form.ip || "").trim(),
      equipo: Number(form.equipo || 0),  // 0/1
      comentario: (form.comentario || "").trim(),

      // Instalación siempre
      instalacion: {
        costo: Number(instalacionCosto),
        tipo: instalacionTipo, // "contado" | "meses"
        meses: instalacionTipo === "contado" ? 1 : Number(instalacionMeses),
      },
    };

    onGuardar(payload);
  }

  return (
    <div className="modal-backdrop-cliente-wifi">
      <div className="modal-cliente-wifi">
        <h2>Agregar Cliente WiFi</h2>

        <div className="form-grid-wifi">
          <input placeholder="ID Cliente" value={form.id} onChange={handleChangeID} />

          <input
            placeholder="Nombre"
            value={form.nombre}
            onChange={(e) => actualizarCampo("nombre", e.target.value)}
          />

          <input
            placeholder="Apellidos"
            value={form.apellidos}
            onChange={(e) => actualizarCampo("apellidos", e.target.value)}
          />

          <input
            placeholder="Dirección"
            value={form.direccion}
            onChange={(e) => actualizarCampo("direccion", e.target.value)}
          />

          <input
            placeholder="Teléfono"
            value={form.telefono}
            onChange={(e) => actualizarCampo("telefono", e.target.value)}
          />

          <input
            placeholder="Colonia"
            value={form.colonia}
            onChange={(e) => actualizarCampo("colonia", e.target.value)}
          />

          <input
            placeholder="Municipio"
            value={form.municipio}
            onChange={(e) => actualizarCampo("municipio", e.target.value)}
          />

          {/* PLAN (igual que fibra) */}
          <select value={form.plan} onChange={(e) => seleccionarPlan(e.target.value)}>
            <option value="">Seleccione un plan...</option>
            {planes.map((p) => (
              <option key={p.id} value={p.nombre}>
                {p.nombre} ${p.costo}
              </option>
            ))}
          </select>

          <input placeholder="Costo" type="number" value={form.costo} readOnly />

          {/* Localidad. Antes era un desplegable con una sola opción de
              valor 2, mientras el formulario nacía con 1: los dos decían
              "Centro" y el dato quedaba a merced de si alguien lo tocaba. */}
          <select
            value={form.nodo_id}
            onChange={(e) => actualizarCampo("nodo_id", e.target.value)}
          >
            <option value="">Localidad…</option>
            {nodos.map((n) => (
              <option key={n.id} value={n.id}>{n.nombre}</option>
            ))}
          </select>
          {errorNodos && <small className="aviso-nodos">{errorNodos}</small>}

          <input
            placeholder="IP"
            value={form.ip}
            onChange={(e) => actualizarCampo("ip", e.target.value)}
          />

          <select value={form.equipo} onChange={(e) => actualizarCampo("equipo", e.target.value)}>
            <option value="0">Equipo propio</option>
            <option value="1">Equipo prestado</option>
          </select>
        </div>

        <textarea
          placeholder="Comentario"
          value={form.comentario}
          onChange={(e) => actualizarCampo("comentario", e.target.value)}
        />

        <h3 style={{ marginTop: "20px" }}>Instalación</h3>

        <div className="form-grid-wifi">
          <input
            type="number"
            placeholder="Costo instalación"
            value={instalacionCosto}
            onChange={(e) => setInstalacionCosto(e.target.value)}
          />

          <select value={instalacionTipo} onChange={(e) => setInstalacionTipo(e.target.value)}>
            <option value="contado">Contado</option>
            <option value="meses">Meses sin intereses</option>
          </select>

          {instalacionTipo === "meses" && (
            <select value={instalacionMeses} onChange={(e) => setInstalacionMeses(Number(e.target.value))}>
              {[1, 2, 3, 4, 5, 6].map((n) => (
                <option key={n} value={n}>
                  {n} mes(es)
                </option>
              ))}
            </select>
          )}
        </div>

        <div className="modal-buttons-wifi">
          <button className="btn-cancelar-wifi" onClick={onClose}>
            Cancelar
          </button>
          <button className="btn-guardar-wifi" onClick={guardar}>
            Guardar Cliente
          </button>
        </div>
      </div>
    </div>
  );
}

